<template>
  <aside :class="$style.mobileAppsAd">

    <div :class="$style.mobileAdvantages">
      <h4 :class="$style.sloganTitle">Become a Boss</h4>
      <h3 :class="$style.mobileAppAdTitle">
        Look up past orders, Faster ordering, and more!
      </h3>
      <ul :class="$style.advantagesList">
        <li v-for="advantage in advantages"
            :key="advantage.id"
            :class="$style.advantagesListItem">
          <div :class="$style.checkmark">
            <svg v-svg
                 :class="$style.checkmarkWhite"
                 symbol="checkmark-icon"/>
          </div>

          <p>{{ advantage.text }}</p>

        </li>
      </ul>

      <BaseButton :button-style="'Back'"
                  :class="$style.advBtn"
                  @click="goToCreateAccount">
        Get Started</BaseButton>
    </div>

    <div :class="$style.downloadApp">
      <h3 :class="$style.mobileAppAdTitle">
        Order directly from your mobile phone!
      </h3>
      <div :class="$style.mobileAppAvailable">
        <h6>Burger Boss mobile apps <span>NOW AVAILABLE</span> </h6>
        <div :class="$style.mobileArrowImage">
          <svg v-svg
               :class="$style.longArrowIcon"
               symbol="long-arrow"/>
        </div>
      </div>

      <img :class="$style.mobileImage"
           src="@/assets/img/image_iPhone.jpg"
           alt="iPhone">

      <div :class="$style.downloadButtons">
        <a :class="$style.appStoreBtn"
           href="#">
          <img src="@/assets/img/app_store.png"
               alt="Download on the AppStore">
        </a>
        <a :class="$style.googlePlayBtn"
           href="#">
          <img src="@/assets/img/google_play.png"
               alt="Get it on Google Play">
        </a>
      </div>
    </div>

    <span :class="$style.newLabel">New</span>
  </aside>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';

  @Component({
    name:       'DesktopAdv.vue',
    components: {
      BaseButton,
    },
  })
export default class DesktopAdd extends Vue {
    advantages = [
      {
        id:   1,
        text: 'Register a phone number at our kiosk, online, or through our mobile app.',
      },
      {
        id:   2,
        text: 'Use this phone number when you order.',
      },
      {
        id:   3,
        text: 'Re-order up to 5 of your past orders, quickly and easily!',
      },
    ];
    goToCreateAccount() {
      this.$router.push({ name: 'create-account', params: { goAfterCreation: '/' } });
    }
  }
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";
  @import "@/style/helpers.scss";

  .mobileAppsAd {
    margin-right: -15px;
    min-height: 100%;
    background: url("/assets/img/green.png") repeat;
    padding: 20px 17px 18px 20px;
    color: $white;
    position: relative;
  }

  .mobileAdvantages {
    padding: 0 12px 39px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 8px;
      top: calc(100% - 8px);
      left: 0;
      background: url("/static/pattern.png") repeat-x;
    }
  }

  .sloganTitle {
    color: $black;
    font-family: "LP Bambus", sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 33px;
    transform: rotate(-6deg);
  }

  .mobileAppAdTitle {
    color: $white;
    font-size: 24px;
    line-height: 28px;
    text-transform: uppercase;
    text-align: center;
    margin-top: 20px;
    padding-bottom: 20px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 134px;
      height: 7px;
      top: calc(100% - 7px);
      left: calc(50% - 67px);
      background-color: $black;
    }
  }

  .advantagesList {
    list-style: none;
    padding-left: 0;
    margin-bottom: 27px;
    margin-top: 32px;
  }

  .advantagesListItem {
    padding: 0 19px;
    margin-bottom: 20px;
    display: flex;
    p {
      color: $white;
    }
  }

  .advantagesListItem:last-child {
    margin-bottom: 0;
  }

  .checkmark {
    width: 19px;
    height: 19px;
    background-color: $white;
    border-radius: 50%;
    margin-right: 24px;
    .checkmarkWhite {
      width: 19px;
      height: 19px;
      fill: $green-color;
    }
  }

  .advBtn {
    display: block;
    padding: 26px 88px;
    background-color: $white;
    border-radius: 37.5px;
    margin: 0 auto;
    outline: none;
    div {
      color: $black-slightly-transparent;
      font-family: 'Gotham', sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      text-align: center;
      text-transform: uppercase;
    }
  }

  .downloadApp {
    padding-top: 9px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .mobileAppAvailable {
    position: relative;
    display: inline-block;
    margin: 20px auto;
    h6 {
      font-weight: 400;
      text-align: center;
    }
    h6 span {
      font-weight: 700;
      text-transform: uppercase;
    }
  }

  .mobileArrowImage {
    position: absolute;
    right: 30px;
    top: calc(100% + 18px);
    .longArrowIcon {
      width: 23px;
      height: 66px;
      fill: $black;
    }
  }

  .mobileImage {
    display: block;
    margin: 0 auto;
    max-width: 154px;
  }

  .downloadButtons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    padding: 0 16px;
    a {
      margin: 0 5px;
      width: calc(50% - 10px);
    }
    img {
      width: 100%;

    }
  }

  .newLabel {
    position: absolute;
    top: 17px;
    right: 16px;
    width: 50px;
    height: 24px;
    border-radius: 12px;
    background-color: $white;
    color: $green-color;
    font-family: 'Gotham', sans-serif;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    text-align: center;
    line-height: 26px;
  }

  @media screen and (max-width: 1280px) {
    .advBtn {
      width: 100%;
    }

    .mobileAppAdTitle {
      font-size: 22px;
      line-height: 24px;
    }
    .downloadButtons {
      flex-direction: column;
      a {
        width: calc(100% - 10px);
        max-width: 200px;
        margin-bottom: 10px;
      }
    }
  }

  @media screen and (max-width: 959px) {
    .mobileAppsAd {
      margin-left: -15px;
    }

    .downloadButtons {
      flex-direction: row;
      justify-content: center;
      a {
        width: calc(50% - 10px);
        max-width: 200px;
        margin-bottom: 0;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .mobileAppsAd {
      padding: 10px;
    }

    .advBtn {
      padding: 16px;
      font-size: 16px;
    }

    .downloadButtons {
      flex-direction: column;
      a {
        width: calc(100% - 10px);
        max-width: 200px;
        margin-bottom: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopAdv.vue